import { post } from "../../../Services/http";

export const submitCustomerApplicationForm = (customerApplicationFormApiModel: any) => {
    return post(`/api/forms/customerapplication`, customerApplicationFormApiModel);
}